import React, { useState, useEffect } from "react";
import { IconX } from "@tabler/icons-react";

const COLORS = [
  "#3b82f6", "#06b776", "#f59e0b", "#ef4444", "#8b5cf6",
  "#ec4899", "#06b6d4", "#f97316", "#6366f1", "#14b8a6",
];

const STAGE_TYPES = [
  { value: "open", label: "Aberto" },
  { value: "won", label: "Ganho" },
  { value: "lost", label: "Perdido" },
];

const ColumnForm = ({ column, onSave, onClose }) => {
  const [name, setName] = useState("");
  const [color, setColor] = useState("#3b82f6");
  const [probability, setProbability] = useState(0);
  const [maxDays, setMaxDays] = useState("");
  const [stageType, setStageType] = useState("open");
  const [error, setError] = useState("");

  useEffect(() => {
    if (column) {
      setName(column.name || "");
      setColor(column.color || "#3b82f6");
      setProbability(column.probability || 0);
      setMaxDays(column.max_days || "");
      setStageType(column.stage_type || "open");
    } else {
      setName("");
      setColor("#3b82f6");
      setProbability(0);
      setMaxDays("");
      setStageType("open");
    }
  }, [column]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim()) {
      setError("Nome é obrigatório");
      return;
    }
    onSave({
      ...(column || {}),
      name: name.trim(),
      color,
      probability: Number(probability),
      max_days: maxDays ? Number(maxDays) : null,
      stage_type: stageType,
    });
  };

  return (
    <div className="crm-modal-backdrop" onClick={onClose}>
      <div className="crm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="crm-modal__header">
          <h3 className="crm-modal__title">{column ? "Editar Coluna" : "Nova Coluna"}</h3>
          <button className="crm-drawer__close" onClick={onClose}>
            <IconX size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="crm-modal__body">
            <div className="crm-form-group">
              <label className="crm-label">Nome da Coluna</label>
              <input
                className={`crm-input ${error ? "crm-input--error" : ""}`}
                value={name}
                onChange={(e) => { setName(e.target.value); setError(""); }}
                autoFocus
                placeholder="Ex: Prospecção"
              />
              {error && <div className="crm-error-text">{error}</div>}
            </div>

            <div className="crm-form-group">
              <label className="crm-label">Cor</label>
              <div className="crm-color-picker">
                {COLORS.map((c) => (
                  <div
                    key={c}
                    className={`crm-color-picker__swatch ${color === c ? "crm-color-picker__swatch--active" : ""}`}
                    style={{ background: c }}
                    onClick={() => setColor(c)}
                  />
                ))}
              </div>
            </div>

            <div className="crm-form-row">
              <div className="crm-form-group">
                <label className="crm-label">Probabilidade (%)</label>
                <input
                  type="number"
                  className="crm-input"
                  value={probability}
                  onChange={(e) => setProbability(Math.min(100, Math.max(0, e.target.value)))}
                  min="0"
                  max="100"
                />
              </div>

              <div className="crm-form-group">
                <label className="crm-label">Dias Máx. no Estágio</label>
                <input
                  type="number"
                  className="crm-input"
                  value={maxDays}
                  onChange={(e) => setMaxDays(e.target.value)}
                  placeholder="Sem limite"
                  min="1"
                />
              </div>
            </div>

            <div className="crm-form-group">
              <label className="crm-label">Tipo de Estágio</label>
              <select className="crm-select" value={stageType} onChange={(e) => setStageType(e.target.value)}>
                {STAGE_TYPES.map((st) => (
                  <option key={st.value} value={st.value}>{st.label}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="crm-modal__footer">
            <button type="button" className="crm-btn" onClick={onClose}>Cancelar</button>
            <button type="submit" className="crm-btn crm-btn--primary">Salvar</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ColumnForm;
